import React, { useCallback } from 'react';
import { ServicesContext } from '../ServicesContext';
import { HealthHxItemType, healthHxTabs } from '~/util/healthHx';

type HealthHxTab = (typeof healthHxTabs)[keyof typeof healthHxTabs];

interface HealthHxResponseData {
    errorCode?: string;
    data: Record<string, HealthHxItemType[]>;
}

const tabConfig: Record<string, { path: string; val: string }> = {
    [healthHxTabs.labs]: { path: 'labs', val: 'memberLabs' },
    [healthHxTabs.meds]: { path: 'medications', val: 'memberMedication' },
    [healthHxTabs.specVisits]: { path: 'specialty-visits', val: 'memberSpecialtyVisits' },
    [healthHxTabs.diagnosis]: { path: 'diagnosis', val: 'memberDiagnosis' },
    [healthHxTabs.vitals]: { path: 'vitals', val: 'memberVital' },
    [healthHxTabs.inptOutpt]: { path: 'in-out-patients', val: 'memberInOutPatient' },
};

export const useGetHealthHistory = () => {
    const services = React.useContext(ServicesContext);

    const getHealthHistory = useCallback(
        async (gmpi: number, type: HealthHxTab): Promise<HealthHxItemType[]> => {
            const config = tabConfig[type];
            if (!config) return [];

            const result: ApiDataResponseType<HealthHxResponseData> = await services.api.call(
                {
                    method: 'get',
                    url: `/wellmed/api/gmpi/${gmpi}/${config.path}`,
                },
                { handledErrors: true }
            );

            if (result.data?.errorCode === 'NoResultsFound') return [];

            return result.data.data[config.val].map((x, i) => ({ ...x, id: i }));
        },
        [services.api]
    );

    return getHealthHistory;
};
